import { useEffect, useState } from "react"
import { ResumenCorteTickets } from "src/pages/Cortes/Sections/ResumenTurno/interfaces/resumenCorteTickets"
import { minus } from "src/shared/helpers/calculator"
import { formatCurrency } from "src/shared/hooks/formatCurrency"
import { COLLECTION } from "src/shared/icons/Icon"

interface Concepto {
    title: {
        text: string
        icon: keyof typeof COLLECTION | (string & {})
    }
    items: {
        icon?: keyof typeof COLLECTION | (string & {})
        text: string
        value: string
    }[]
    total: {
        text: string
        value: string
    }
}

interface Resumen {
    ingresos: Concepto[]
    egresos: Concepto[]
    total_ingresos: number
    total: number
}

interface Ingreso {
    text: string
    value: string
}

export function useDataResumen({resumen: resumenCorteTickets}: {resumen?: ResumenCorteTickets}) {
    const [dataResumen, setDataResumen] = useState<any>({})
    const [dataIngresos, setDataIngresos] = useState<any>({})

    const getDataResumen = (data: ResumenCorteTickets): Resumen => {
        const total_ingresos = data.dashboard.total_ventas

        const total = data.dashboard.total_turno

        const resumen: Resumen = {
            ingresos: [
                {
                    title: { text: "Estancia", icon: "openDoor" },
                    items: [
                        {
                            text: "Efectivo",
                            value: formatCurrency(Number(data?.metodos_pago?.habitaciones?.efectivo || 0)),
                        },
                        {
                            icon: "visa",
                            text: "Visa o Mastercard",
                            value: formatCurrency(Number(data?.metodos_pago?.habitaciones?.visa_master || 0)),
                        },
                        {
                            icon: "amex",
                            text: "AMEX",
                            value: formatCurrency(Number(data?.metodos_pago?.habitaciones?.amex || 0)),
                        },
                        {
                            text: "Depósito/Transfer",
                            value: formatCurrency(Number(data?.metodos_pago?.habitaciones?.deposito || 0)),
                        },
                        {
                            text: "Cortesía",
                            value: formatCurrency(Number(data?.metodos_pago?.habitaciones?.cortesia || 0)),
                        },
                        {
                            text: "Consumo interno",
                            value: formatCurrency(Number(data?.metodos_pago?.habitaciones?.consumo_interno || 0)),
                        },
                        {
                            text: "Love points",
                            value: formatCurrency(Number(data?.metodos_pago?.habitaciones?.easy_rewards || 0)),
                        },
                        {
                            text: "Descuentos",
                            value: formatCurrency(Number(data?.metodos_pago?.habitaciones?.descuentos || 0)),
                        },
                        {
                            text: "Anticipos válidos",
                            value: formatCurrency(Number(resumenCorteTickets?.dashboard?.anticipos_validos || 0)),
                        },
                    ],
                    total: {
                        text: "Total",
                        value: formatCurrency(Number(data?.metodos_pago?.habitaciones?.total || 0)),
                    },
                },
                {
                    title: { text: "Room service", icon: "coffee" },
                    items: [
                        {
                            text: "Efectivo",
                            value: formatCurrency(Number(data?.metodos_pago?.room_service?.efectivo || 0)),
                        },
                        {
                            icon: "visa",
                            text: "Visa o Mastercard",
                            value: formatCurrency(Number(data?.metodos_pago?.room_service?.visa_master || 0)),
                        },
                        {
                            icon: "amex",
                            text: "AMEX",
                            value: formatCurrency(Number(data?.metodos_pago?.room_service?.amex || 0)),
                        },
                        {
                            text: "Depósito/Transfer",
                            value: formatCurrency(Number(data?.metodos_pago?.room_service?.deposito || 0)),
                        },
                        {
                            text: "Cortesía",
                            value: formatCurrency(Number(data?.metodos_pago?.room_service?.cortesia || 0)),
                        },
                        {
                            text: "Consumo interno",
                            value: formatCurrency(Number(data?.metodos_pago?.room_service?.consumo_interno || 0)),
                        },
                        {
                            text: "Love points",
                            value: formatCurrency(Number(data?.metodos_pago?.room_service?.easy_rewards || 0)),
                        },
                    ],
                    total: {
                        text: "Total",
                        value: formatCurrency(Number(data?.metodos_pago?.room_service?.total || 0)),
                    },
                },
                {
                    title: { text: "Restaurante", icon: "restaurantFill" },
                    items: [
                        {
                            text: "Efectivo",
                            value: formatCurrency(Number(data?.metodos_pago?.restaurante?.efectivo || 0)),
                        },
                        {
                            icon: "visa",
                            text: "Visa o Mastercard",
                            value: formatCurrency(Number(data?.metodos_pago?.restaurante?.visa_master || 0)),
                        },
                        {
                            icon: "amex",
                            text: "AMEX",
                            value: formatCurrency(Number(data?.metodos_pago?.restaurante?.amex || 0)),
                        },
                        {
                            text: "Cortesía",
                            value: formatCurrency(Number(data?.metodos_pago?.restaurante?.cortesia || 0)),
                        },
                        {
                            text: "Consumo interno",
                            value: formatCurrency(Number(data?.metodos_pago?.restaurante?.consumo_interno || 0)),
                        },
                        {
                            text: "Love points",
                            value: formatCurrency(Number(data?.metodos_pago?.restaurante?.easy_rewards || 0)),
                        },
                        
                    ],
                    total: {
                        text: "Total",
                        value: formatCurrency(Number(data?.metodos_pago?.restaurante?.total || 0)),
                    },
                },
                {
                    title: { text: "Reservaciones", icon: "bookRemix" },
                    items: [
                        {
                            text: "Efectivo",
                            value: formatCurrency(Number(data?.reservas?.efectivo || 0)),
                        },
                        {
                            icon: "visa",
                            text: "Visa o Mastercard",
                            value: formatCurrency(Number(data?.reservas?.visa_master || 0)),
                        },
                        {
                            icon: "amex",
                            text: "AMEX",
                            value: formatCurrency(Number(data?.reservas?.amex || 0)),
                        },
                        {
                            text: "Depósito/Transfer",
                            value: formatCurrency(Number(data?.reservas?.deposito || 0)),
                        },
                        {
                            text: "Cortesía",
                            value: formatCurrency(Number(data?.reservas?.cortesia || 0)),
                        },
                        {
                            text: "Descuentos",
                            value: formatCurrency(Number(data?.metodos_pago?.reservas?.descuentos || 0)),
                        },
                    ],
                    total: {
                        text: "Total",
                        value: formatCurrency(Number(data?.reservas?.total || 0)),
                    },
                },
                {
                    title: { text: "Propinas", icon: "HandCoinFilled" },
                    items: [
                        {
                            text: "Efectivo",
                            value: formatCurrency(Number(data?.metodos_pago?.propinas?.propinas_efectivo || 0)),
                        },
                        {
                            icon: "visa",
                            text: "Visa o Mastercard",
                            value: formatCurrency(Number(data?.metodos_pago?.propinas?.propinas_visaMastercard || 0)),
                        },
                        {
                            icon: "amex",
                            text: "AMEX",
                            value: formatCurrency(Number(data?.metodos_pago?.propinas?.propinas_amex || 0)),
                        },
                    ],
                    total: {
                        text: "Total",
                        value: formatCurrency(Number(data?.metodos_pago?.propinas?.total_propinas || 0)),
                    },
                },
            ],
            egresos: [
                {
                    title: { text: "Gastos", icon: "dollarCircle" },
                    items: [
                        {
                            text: "Efectivo",
                            value: "-" + formatCurrency(Number(data?.metodos_pago?.gastos.efectivo || 0)),
                        },
                        {
                            text: "Anticipos válidos",
                            value: "-" + formatCurrency(Number(resumenCorteTickets?.metodos_pago.habitaciones.anticipos_validos || 0)),
                        },
                    ],
                    total: {
                        text: "Total",
                        value: formatCurrency(minus(Number(data?.dashboard?.gastos || 0), Number(resumenCorteTickets?.metodos_pago.habitaciones.anticipos_validos || 0))),
                    },
                },
            ],
            total_ingresos,
            total: total || 0,
        }

        return resumen
    }
    const getDataIngresos = (data: ResumenCorteTickets): Ingreso[] => {
        const totalEfectivo = Number(resumenCorteTickets?.dashboard?.efectivo || 0);

        const totalVisa = Number(resumenCorteTickets?.dashboard?.visa_mastercard || 0)

        const totalAmex = Number(resumenCorteTickets?.dashboard?.amex || 0)

        const total_cortesia = Number(resumenCorteTickets?.dashboard?.cortesia || 0)

        const total_consumo_interno = Number(resumenCorteTickets?.dashboard?.consumo_interno || 0)

        const total_easy_rewards = Number(resumenCorteTickets?.dashboard?.easy_rewards || 0)

        const total_descuentos = Number(resumenCorteTickets?.dashboard?.descuentos || 0)
        
        const totales = [
            {
                text: "Efectivo",
                value: formatCurrency(Number(totalEfectivo || 0)),
            },
            {
                text: "Visa o Mastercard",
                value: formatCurrency(Number(totalVisa || 0)),
            },
            {
                text: "AMEX",
                value: formatCurrency(Number(totalAmex || 0)),
            },
            {
                text: "Depósito/Transfer",
                value: formatCurrency(Number(data?.reservas?.deposito || 0)),
            },
            // {
            //     text: "Fajillas",
            //     value: formatCurrency(Number(data?.dashboard.total_fajillas || 0)),
            // },
            {
                text: "Cortesías",
                value: "-" + formatCurrency(total_cortesia || 0),
            },
            {
                text: "Consumo interno",
                value: "-" + formatCurrency(total_consumo_interno || 0),
            },
            {
                text: "Love points",
                value: "-" + formatCurrency(total_easy_rewards || 0),
            },
            {
                text: "Descuentos",
                value: "-" + formatCurrency(total_descuentos || 0),
            },
            {
                text: "Anticipos válidos",
                value: formatCurrency(Number(resumenCorteTickets?.dashboard?.anticipos_validos || 0)),
            },
        ]

        return totales
    }

    useEffect(() => {
        if (resumenCorteTickets) {
            setDataResumen(getDataResumen(resumenCorteTickets))
            setDataIngresos(getDataIngresos(resumenCorteTickets))
        } else {
            setDataResumen([])
            setDataIngresos([])
        }
    }, [resumenCorteTickets])

    return { dataResumen: dataResumen as Resumen, dataIngresos: dataIngresos as Ingreso[] }
}
